import lightBlue from '@material-ui/core/colors/lightBlue';
import { alpha } from '@material-ui/core/styles';

export const highlightColorRGBA = alpha(lightBlue[500], 0.2);
